import axios from 'axios'
import API from './index'

export default {
  get(id) {
    const url = API.BASE_URL + 'Associations/' + id
    return axios.get(url, {}).then(response => {
      return response.data
    })
  },
  getFlights() {
    const url = API.BASE_URL + 'Associations/getFlights'
    return axios.get(url, {}).then(response => {
      return response.data
    })
  },
  getWinningTypes() {
    const url = API.BASE_URL + 'Associations/getWinningTypes'
    return axios.get(url, {}).then(response => {
      return response.data
    })
  },

  update(association) {
    const url = API.BASE_URL + 'Associations/' + association.associationId
    return axios.put(url, association).then(response => {
      return response.data
    })
  }
}
